import { CSSObject, styled, Theme } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import InputBase from '@mui/material/InputBase';
import React from 'react';

import SearchIcon from '@/assets/icons/search.svg?react';
import { useTranslator } from '@/hooks/useTranslator';
import { blockPropagation } from '@/utility/blockPropagation';

interface Props {
  readonly placeholder?: string;
  readonly fullWidth?: boolean;
  readonly disabled?: boolean;

  onChange?(event: React.ChangeEvent<HTMLInputElement>): void;
  onKeyDownCapture?(event: React.KeyboardEvent<HTMLInputElement>): void;
}

export const SearchBox: React.FC<Props> = (props: Props): React.ReactElement => {
  const { placeholder, fullWidth = false, disabled = false, onChange, onKeyDownCapture } = props;
  const tr = useTranslator();

  const SearchButton = React.useCallback(function SearchButton(): React.ReactElement {
    return (
      <IconButton size="small" color="inherit">
        <SearchIcon fill="currentColor" />
      </IconButton>
    );
  }, []);

  return (
    <CustomTextField
      placeholder={placeholder ?? tr('SEARCH')}
      endAdornment={<SearchButton />}
      fullWidth={fullWidth}
      disabled={disabled}
      autoFocus={true}
      onKeyDownCapture={onKeyDownCapture}
      onMouseDownCapture={blockPropagation}
      onChange={onChange}
    />
  );
};

const CustomTextField = styled(InputBase)(
  ({ theme: { palette } }: { readonly theme: Theme }): CSSObject => ({
    lineHeight: '40px',
    padding: '0 16px 0 24px',
    borderRadius: 20,
    backgroundColor: palette.custom.InputsBackground,
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: palette.custom.DividerLight,
    height: 40,
    '&.Mui-disabled': {
      backgroundColor: palette.custom.InactiveBackground,
      color: palette.text.primary,
      WebkitTextFillColor: palette.text.primary,
    },
  }),
);
